// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__y8eCE","bigColWidth":"Table_bigColWidth__2TfbW","biggerColWidth":"Table_biggerColWidth__2u9GX","row":"Table_row__3mle4","col":"Table_col__3HEC_"};